import { FormFieldType } from '@atom/types/form';

import classes from '../formInstance.module.css';

interface PassedProps {
  field: FormFieldType;
}

type Props = PassedProps;

const TitleField = ({ field }: Props) => {
  return (
    <div className={classes.fieldBlock}>
      <div className={classes.titleFieldText}>{field.text}</div>
    </div>
  );
};

export default TitleField;
